
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sdk/mobile-payments/android",
      function () {
        return require("private-next-pages/docs/sdk/mobile-payments/android.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sdk/mobile-payments/android"])
      });
    }
  